import { Gamepad2, Wallet, Gift, Handshake, type LucideIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export type TabV2 = 'play' | 'assets' | 'tasks' | 'partner';

interface NavigationV2Props {
  active: TabV2;
  onChange: (tab: TabV2) => void;
  variant: 'bottom' | 'side';
  /** Optional countdown label rendered as a badge on the Play anchor. */
  playBadge?: string | null;
}

const TABS: { id: TabV2; labelKey: string; Icon: LucideIcon }[] = [
  { id: 'play', labelKey: 'v2.nav.play', Icon: Gamepad2 },
  { id: 'assets', labelKey: 'v2.nav.assets', Icon: Wallet },
  { id: 'tasks', labelKey: 'v2.nav.tasks', Icon: Gift },
  { id: 'partner', labelKey: 'v2.nav.partner', Icon: Handshake },
];

export function NavigationV2({ active, onChange, variant, playBadge }: NavigationV2Props) {
  const { t } = useTranslation();
  return (
    <nav
      className={`app-nav app-nav--${variant} nav-v2`}
      aria-label={t('nav.aria')}
    >
      {TABS.map((tab) => {
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            className={`app-nav__item ${isActive ? 'app-nav__item--active' : ''}`}
            onClick={() => onChange(tab.id)}
            aria-current={isActive ? 'page' : undefined}
          >
            <span className="nav-v2__iconwrap">
              <tab.Icon className="app-nav__icon" size={21} strokeWidth={2.1} aria-hidden="true" />
              {tab.id === 'play' && playBadge && (
                <span className="nav-v2__badge">{playBadge}</span>
              )}
            </span>
            <span className="app-nav__label">{t(tab.labelKey)}</span>
          </button>
        );
      })}
    </nav>
  );
}
